module.exports = __webpack_public_path__ + "static/media/Hair_2_dark_brown.efcdb7a0.svg";